import { requireModule } from '../../auth/guards';
import { MODULES } from '../../auth/permissions';
import ContactSubmissionsPage from './pages/ContactSubmissionsPage';

export const websiteRoutes = [
  {
    path: '/contact-submissions',
    element: <ContactSubmissionsPage />,
    handle: { breadcrumb: 'Contact Us Submissions' },
    loader: requireModule(MODULES.WEBSITE),
  },
];
